import React from 'react'
import { useDispatch } from 'react-redux';
import { openModal } from '../../store/actions/modalAction';
import { Box, Paper, Typography, Button, styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DataTable from '../../components/tables/DataTable';
import PaddingBoxInDesktop from '../../components/layouts/PaddingBoxInDesktop';
import { Add } from '@mui/icons-material';
import SubmitButton from '../../components/button/SubmitButton';
import { StyledSearchBar } from '../../components/inputs/SearchBar';




const FilterTitleBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }

}))
const FiltersBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }
}))

const VersionListUi = ({ columns, list, filters, setFilters, loading,onCreateBtnClick }) => {

  const id = 'version';

  return (
    <>
    <Box mb={3}>
                <Paper elevation={2} sx={{ width: "100%", padding: 4 }} >
          <Box mb={4} >
                        <FilterTitleBox>
                            <Typography variant="h5" mb={2} >Version</Typography>

                            <Box mb={2}>
                                <SubmitButton variant="contained" onClick={onCreateBtnClick} title={"Add Version"} />
                            </Box>

                        </FilterTitleBox>


                        <FiltersBox mt={3} >
                           <PaddingBoxInDesktop mb={2} ml={"65%"} sx={{ height: "40px",
                                                          display: "flex", flex: 1, justifyContent: "flex-end", "*": {
                                                              justifyContent: "center"
                                                          }
                                                      }} pl={3} >
                                                          <StyledSearchBar fullWidth title="Search By  Name " size="small" placeholder={"Search By  Name "} value={filters.search} onChange={(e) => { setFilters({ ...filters, search: e.target.value }) }} />
                                                      </PaddingBoxInDesktop>
                          
                          
                          
                                                  </FiltersBox>
                                                   </Box>

          <Box sx={{ minHeight: "40vh" }}>
            <DataTable columns={columns} rows={list?.result ? list?.result : []} count={list?.total ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
          </Box>
        </Paper>
      </Box>

    </>
  )
}

export default VersionListUi